import React, { useState } from 'react';
import { Link, useParams, useNavigate } from 'react-router-dom';
import Layout from '../../../component/layout';

// Import tab components
import MeterInfoTab from './view_meter_tabs/meterInfoTab';
import ReadingHistoryTab from './view_meter_tabs/readingHistoryTab';
import CustomerDetailsTab from './view_meter_tabs/customerDetailsTab';
import TransactionsTab from './view_meter_tabs/transactionsTab';
import CommunicationLogsTab from './view_meter_tabs/communicationLogsTab';

function ViewWaterMeter() {
    const { meterId } = useParams();
    const [activeTab, setActiveTab] = useState('meter-info');
    const [transactions] = useState([]);
    
    return (
        <Layout>
            <div className="row">
                <div className="col-sm-12">
                    {/* Breadcrumb Section */}
                    <div className="page-header">
                        <div className="page-block">
                            <div className="row align-items-center">
                                <div className="col-md-12">
                                    <ul className="breadcrumb">
                                        <li className="breadcrumb-item">
                                            <Link to="/facility">Dashboard</Link>
                                        </li>
                                        <li className="breadcrumb-item">
                                            Meter Management
                                        </li>
                                        <li className="breadcrumb-item">
                                            Water Meters
                                        </li>
                                        <li className="breadcrumb-item">
                                            Meter Details
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="card">
                        <div className="card-header">
                            <Link
                                to="/facility/utility_management/meter_management/water_meters"
                                state={{ activeTab: "smart-meters" }}
                            >
                                <i className="ti ti-arrow-narrow-left"></i> Back
                            </Link>
                        </div>
                    </div>
                    <div className="card">
                        <div className="card-body py-0">
                            <ul className="nav nav-tabs profile-tabs">
                                <li className="nav-item">
                                    <button
                                        className={`nav-link ${activeTab === 'meter-info' ? 'active' : ''}`}
                                        onClick={() => setActiveTab('meter-info')}
                                        type="button"
                                    >
                                        <i className="ti ti-dashboard me-2"></i>Meter Info
                                    </button>
                                </li>
                                <li className="nav-item">
                                    <button
                                        className={`nav-link ${activeTab === 'readings' ? 'active' : ''}`}
                                        onClick={() => setActiveTab('readings')}
                                        type="button"
                                    >
                                        <i className="ti ti-list-numbers me-2"></i>Reading History
                                    </button>
                                </li>
                                <li className="nav-item">
                                    <button
                                        className={`nav-link ${activeTab === 'customer' ? 'active' : ''}`}
                                        onClick={() => setActiveTab('customer')}
                                        type="button"
                                    >
                                        <i className="ti ti-users me-2"></i>Assigned Customers
                                    </button>
                                </li>
                                <li className="nav-item">
                                    <button
                                        className={`nav-link ${activeTab === 'transactions' ? 'active' : ''}`}
                                        onClick={() => setActiveTab('transactions')}
                                        type="button"
                                    >
                                        <i className="ti ti-cash me-2"></i>Transactions
                                    </button>
                                </li>
                                <li className="nav-item">
                                    <button
                                        className={`nav-link ${activeTab === 'communication-logs' ? 'active' : ''}`}
                                        onClick={() => setActiveTab('communication-logs')}
                                        type="button"
                                    >
                                        <i className="ti ti-message-dots me-2"></i>Communication Logs
                                    </button>
                                </li>
                            </ul>

                            <div className="tab-content" style={{ paddingTop: '2rem' }}>
                                {activeTab === 'meter-info' && (
                                    <MeterInfoTab meterId={meterId} />
                                )}
                                {activeTab === 'readings' && (
                                    <ReadingHistoryTab 
                                        meterId={meterId}
                                    />
                                )}
                                {activeTab === 'customer' && (
                                    <CustomerDetailsTab meterId={meterId} />
                                )}
                                {activeTab === 'transactions' && (
                                    <TransactionsTab
                                        transactions={transactions}
                                        loading={false}
                                    />
                                )}
                                {activeTab === 'communication-logs' && (
                                    <CommunicationLogsTab
                                        meterId={meterId}
                                    />
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    );
}

export default ViewWaterMeter;